import { Edit, SimpleForm } from "react-admin";
import { SadaratFormFields } from "./SadaratFormFields";

export default function SadaratsEdit() {
  return (
    <Edit redirect="list">
      <SimpleForm>
        <SadaratFormFields />
      </SimpleForm>
    </Edit>
  );
}
